import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent, HttpResponse, HttpErrorResponse } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';
import { LOGIN_TOKEN_KEY } from '../../constants/auth.constants';

@Injectable()
export class MakpakhttpInterceptor implements HttpInterceptor {
  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    console.log("[MakpakhttpInterceptor] Request", {
      url: request.url,
      method: request.method,
      headers: request.headers.keys(),
      body: request.body
    });
    const token = sessionStorage.getItem(LOGIN_TOKEN_KEY);
    if (token) {
      // Attach standard Authorization header to all requests
      request = request.clone({ setHeaders: { 'ciamAuthorization': `Bearer ${token}` } });

    }

    return next.handle(request).pipe(
      tap(event => {
        if (event instanceof HttpResponse) {
          // Lightweight response logging; adjust detail if payloads are large.
          console.log('[MakpakhttpInterceptor] Response', {
            url: event.url,
            status: event.status,
            statusText: event.statusText,
            headers: event.headers.keys(),
            body: event.body
          });
        }
      }),
      catchError((error: HttpErrorResponse) => {
        console.error('[MakpakhttpInterceptor] Error', {
          url: request.url,
          status: error.status,
          message: error.message,
          error: error.error
        });
        return throwError(() => error);
      })
    );
  }
}
